import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import {
  FaArrowAltCircleRight,
  FaFile,
  FaFilePdf,
  FaHistory,
  FaLanguage,
} from "react-icons/fa";

import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";

import {
  Box,
  Button,
  Divider,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Chip,
} from "@mui/material";

import {
  Update,
  Refresh,
  Search,
  Description,
  Translate,
  History,
  Block,
  PictureAsPdf,
  School,
} from "@mui/icons-material";

import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import { useParams } from "react-router-dom";

// ============================================================
// CONFIGURACIÓN
// ============================================================

const API_URL = "https://middlewarebackprd.azurewebsites.net/api/v1";

// IMPORTANTE:
// No es recomendable tener usuario/password directamente
// en React. Lo ideal es mover esta autenticación al backend.
const API_AUTH = {
  username: "admin.icontec@icontec.org",
  password: "quAngEraMuSTerGerEDE",
};

// ============================================================
// COMPONENTE
// ============================================================

function ConsultarAutenticado() {
  const params = useParams();
  const cookie = useMemo(() => new Cookies(), []);

  // ==========================================================
  // ESTADOS
  // ==========================================================

  const [lista, setLista] = useState([]);
  const [list, setList] = useState([]);

  const [postCertificado, setPostCertificado] = useState("");
  const [postDocumento, setPostDocumento] = useState("");
  const [postEmpresa, setPostEmpresa] = useState("");

  const [loading, setLoading] = useState(false);

  // ==========================================================
  // USUARIO
  // ==========================================================

  const tipoUsuario = cookie.get("tipoUsuario");

  // ==========================================================
  // OBTENER USUARIO
  // ==========================================================

  useEffect(() => {
    let mounted = true;

    const obtenerUsuario = async () => {
      try {
        const response = await axios({
          method: "get",
          auth: API_AUTH,
          url: `${API_URL}/ObtenerUsuario/${params.correo}`,
        });

        if (!mounted) return;

        const usuarios = response.data || [];

        setLista(response.nombre || []);

        console.log("Usuario:", usuarios);

        if (usuarios.length > 0) {
          const usuario = usuarios[0];

          cookie.set("identificacion", usuario.identificacion, {
            path: "/",
          });

          cookie.set("correo", usuario.correo, {
            path: "/",
          });

          cookie.set("ut", usuario.ut, {
            path: "/",
          });

          cookie.set("tipoUsuario", usuario.tipoUsuario, {
            path: "/",
          });

          cookie.set("cargo", usuario.cargo, {
            path: "/",
          });
        }
      } catch (error) {
        console.error("Error obteniendo usuario:", error);
      }
    };

    obtenerUsuario();

    return () => {
      mounted = false;
    };
  }, [params.correo, cookie]);

  // ==========================================================
  // VALIDACIÓN DEL CORREO
  // ==========================================================

  const correoCookie = cookie.get("correo") || "";
  const correoParametro = params.correo || "";

  let correoDecodificado = "";
  let correoDecodificadoParametro = "";

  try {
    correoDecodificado = decodeURIComponent(correoCookie);
  } catch {
    correoDecodificado = correoCookie;
  }

  try {
    correoDecodificadoParametro = decodeURIComponent(correoParametro);
  } catch {
    correoDecodificadoParametro = correoParametro;
  }

  useEffect(() => {
    if (
      correoDecodificado &&
      correoDecodificadoParametro &&
      correoDecodificado !== correoDecodificadoParametro
    ) {
      window.location.href = `${API_URL}/AuthAzure`;
    }
  }, [correoDecodificado, correoDecodificadoParametro]);

  // ==========================================================
  // COLUMNAS
  // ==========================================================

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "ID",
        filterVariant: "text",
        enableEditing: false,
      },
      {
        accessorKey: "id_certificado",
        header: "ID Certificado",
        filterVariant: "text",
        enableEditing: false,
      },
      {
        accessorKey: "emitido",
        header: "Emitido",
        filterVariant: "text",
      },
      {
        accessorKey: "modulo",
        header: "Módulo",
        filterVariant: "text",
      },
      {
        accessorKey: "numero_certificado",
        header: "Número Certificado",
        filterVariant: "text",
      },
      {
        accessorKey: "correo",
        header: "Correo",
        filterVariant: "text",
      },
      {
        accessorKey: "envio_correo",
        header: "Envió correo",
        filterVariant: "text",
      },
      {
        accessorKey: "documento",
        header: "Documento",
        filterVariant: "text",
      },
      {
        accessorKey: "nombre",
        header: "Nombre",
        filterVariant: "text",
      },
      {
        accessorKey: "asistio",
        header: "Asistió",
        filterVariant: "text",
      },
      {
        accessorKey: "certificado",
        header: "Certificado",
        filterVariant: "text",
      },
      {
        accessorKey: "certificado_ingles",
        header: "Certificado Inglés",
        filterVariant: "text",
      },
      {
        accessorKey: "alcance",
        header: "Alcance",
        filterVariant: "text",
      },
      {
        accessorKey: "alcance_ingles",
        header: "Alcance Inglés",
        filterVariant: "text",
      },
      {
        accessorKey: "intensidad",
        header: "Intensidad",
        filterVariant: "text",
      },
      {
        accessorKey: "listado_cursos",
        header: "Listado Cursos",
        filterVariant: "text",
      },
      {
        accessorKey: "ciudad",
        header: "Ciudad",
        filterVariant: "text",
      },
      {
        accessorKey: "pais",
        header: "País",
        filterVariant: "text",
      },
      {
        accessorKey: "fecha_certificado",
        header: "Fecha Certificado",
        filterVariant: "text",
      },
      {
        accessorKey: "fecha_aprobacion",
        header: "Fecha Aprobación",
        filterVariant: "text",
      },
      {
        accessorKey: "fecha_ultima_modificacion",
        header: "Última Modificación",
        filterVariant: "text",
      },
      {
        accessorKey: "fecha_renovacion",
        header: "Fecha Renovación",
        filterVariant: "text",
      },
      {
        accessorKey: "fecha_vencimiento",
        header: "Fecha Vencimiento",
        filterVariant: "text",
      },
      {
        accessorKey: "fecha_impresion",
        header: "Fecha Impresión",
        filterVariant: "text",
      },
      {
        accessorKey: "direccion",
        header: "Dirección",
        filterVariant: "text",
      },

      ...Array.from({ length: 20 }, (_, index) => ({
        accessorKey: `dato_${index + 1}`,
        header: `Dato ${index + 1}`,
        filterVariant: "text",
      })),

      {
        accessorKey: "regional",
        header: "Regional",
        filterVariant: "text",
      },
    ],
    [],
  );

  // ==========================================================
  // PAYLOAD COMÚN
  // ==========================================================

  const obtenerPayload = useCallback((row, incluirId = false) => {
    const payload = {
      modulo: row.getValue("modulo"),
      numero_certificado: row.getValue("numero_certificado"),
      correo: row.getValue("correo"),
      documento: row.getValue("documento"),
      nombre: row.getValue("nombre"),
      certificado: row.getValue("certificado"),
      certidicado_ingles: row.getValue("certificado_ingles"),
      alcance: row.getValue("alcance"),
      alcance_ingles: row.getValue("alcance_ingles"),
      intensidad: row.getValue("intensidad"),
      listado_cursos: row.getValue("listado_cursos"),
      regional: row.getValue("regional"),
      ciudad: row.getValue("ciudad"),
      pais: row.getValue("pais"),
      fecha_certificado: row.getValue("fecha_certificado"),
      fecha_aprobacion: row.getValue("fecha_aprobacion"),
      fecha_ultima_modificaion: row.getValue("fecha_ultima_modificacion"),
      fecha_renovacion: row.getValue("fecha_renovacion"),
      fecha_vencimiento: row.getValue("fecha_vencimiento"),
      fecha_impresion: row.getValue("fecha_impresion"),
      direccion: row.getValue("direccion"),

      dato_1: row.getValue("dato_1"),
      dato_2: row.getValue("dato_2"),
      dato_3: row.getValue("dato_3"),
      dato_4: row.getValue("dato_4"),
      dato_5: row.getValue("dato_5"),
      dato_6: row.getValue("dato_6"),
      dato_7: row.getValue("dato_7"),
      dato_8: row.getValue("dato_8"),
      dato_9: row.getValue("dato_9"),
      dato_10: row.getValue("dato_10"),
      dato_11: row.getValue("dato_11"),
      dato_12: row.getValue("dato_12"),
      dato_13: row.getValue("dato_13"),
      dato_14: row.getValue("dato_14"),
      dato_15: row.getValue("dato_15"),
      dato_16: row.getValue("dato_16"),
      dato_17: row.getValue("dato_17"),
      dato_18: row.getValue("dato_18"),
      dato_19: row.getValue("dato_19"),
      dato_20: row.getValue("dato_20"),

      estado: row.getValue("estado"),
      emitido: row.getValue("emitido"),
    };

    if (incluirId) {
      payload.id_certificado = row.getValue("id_certificado");
    }

    return payload;
  }, []);

  const quitarFila = useCallback((row) => {
    setList((prev) => prev.filter((_, index) => index !== row.index));
  }, []);

  const postData = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const response = await axios({
        method: "post",
        auth: API_AUTH,
        url: `${API_URL}/ObtenerCertificado`,
        data: {
          certificado: postCertificado,
          documento: postDocumento,
          Empresa: postEmpresa,
        },
      });

      if (!response.data || response.data == "") {
        Swal.fire({
          title: "No encontrado",
          text: "La información ingresada no corresponde a un certificado válido.",
          icon: "warning",
        });

        return;
      }

      console.log(response.data);

      setList(response.data);
    } catch (error) {
      console.error(error);

      Swal.fire({
        title: "Error",
        text: "Ocurrió un error. Verifique los campos.",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  // ==========================================================
  // NUEVA CONSULTA
  // ==========================================================

  const Recarga = () => {
    window.location.reload();
  };

  // ==========================================================
  // ABRIR INFORME
  // ==========================================================

  const btnInforme = useCallback((row) => {
    const url = "/#/Informe/" + row.getValue("numero_certificado");

    window.open(url, "_blank");
  }, []);

  const btnInformeBlanco = useCallback((row) => {
    const url = "/#/InformeSinFondo/" + row.getValue("numero_certificado");

    window.open(url, "_blank");
  }, []);

  // ==========================================================
  // GENERAR ENDPOINT
  // ==========================================================

  const generarDocumento = useCallback(
    async ({
      row,
      url,
      title = "Generado",
      incluirId = false,
      reload = false,
      quitar = true,
    }) => {
      try {
        const response = await axios({
          method: "post",
          auth: API_AUTH,
          url,
          data: obtenerPayload(row, incluirId),
        });

        console.log(response.data);

        const result = await Swal.fire({
          title,
          html: `
            <p>
              Documento generado correctamente.
            </p>
            <p>
              <a
                href="${response.data}"
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>🔗 Abrir documento</strong>
              </a>
            </p>
          `,
          icon: "success",
          confirmButtonText: "Cerrar",
          showCloseButton: true,
        });

        if (result.isConfirmed && reload) {
          window.location.reload();
        }

        if (quitar) {
          quitarFila(row);
        }
      } catch (error) {
        console.error(error);

        Swal.fire({
          title: "Error",
          text: "Verifique los campos.",
          icon: "error",
          timer: 4000,
        });
      }
    },
    [obtenerPayload, quitarFila],
  );

  // ==========================================================
  // INTERNO
  // ==========================================================

  const btnInterno = useCallback(
    (row) => {
      generarDocumento({
        row,
        url: `${API_URL}/GeneraEducacion/Educacion01/Educacion`,
        title: "Generado",
      });
    },
    [generarDocumento],
  );

  // ==========================================================
  // ICONTEC BLANCO CON FIRMA
  // ==========================================================

  const btnEnblancoIcontec = useCallback(
    (row) => {
      generarDocumento({
        row,
        url: `${API_URL}/GeneraSG/IC0000001/BLANCO`,
        incluirId: true,
      });
    },
    [generarDocumento],
  );

  // ==========================================================
  // ICONTEC BLANCO SIN FIRMA
  // ==========================================================

  const btnEnblancoIcontecSinFirma = useCallback(
    (row) => {
      generarDocumento({
        row,
        url: `${API_URL}/GeneraSG/IC0000002/SINFIRMA`,
        incluirId: true,
      });
    },
    [generarDocumento],
  );

  // ==========================================================
  // IQNET BLANCO
  // ==========================================================

  const btnEnblancoIQNET = useCallback(
    (row) => {
      generarDocumento({
        row,
        url: `${API_URL}/GeneraSG/IQ000001/IQBLANCO`,
        incluirId: true,
      });
    },
    [generarDocumento],
  );

  // ==========================================================
  // REVOCAR
  // ==========================================================

  const btnRevoca = useCallback(async (row) => {
    try {
      const response = await axios({
        method: "get",
        auth: API_AUTH,
        url: `${API_URL}/revocarCredencial/${row.getValue("id_certificado")}`,
      });

      await Swal.fire({
        title: "Revocado",
        text: "Actualizado",
        icon: "success",
        confirmButtonText: "Aceptar",
      });

      window.location.reload();
    } catch (error) {
      console.error(error);

      Swal.fire({
        title: "Error",
        text: "Verifique los campos.",
        icon: "error",
        timer: 4000,
      });
    }
  }, []);

  // ==========================================================
  // CONSULTAS
  // ==========================================================

  const btnSendInterno = useCallback((row) => {
    const url = `${API_URL}/ConsultaIQ/` + row.getValue("numero_certificado");

    window.open(url, "_blank");
  }, []);

  const btnConsultaSG = useCallback((row) => {
    const url = `${API_URL}/ConsultaSG/` + row.getValue("numero_certificado");

    window.open(url, "_blank");
  }, []);

  const btnHistorial = useCallback((row) => {
    window.location.href = "/#/Historial/" + row.getValue("numero_certificado");
  }, []);

  const btnHistorialGeneral = useCallback((row) => {
    window.location.href =
      `${API_URL}/ConsultaHistorico/` + row.getValue("id_certificado");
  }, []);

  // ==========================================================
  // ACREDITA
  // ==========================================================

  const Acredita = useCallback(
    async (row) => {
      Swal.fire({
        title: "Generando credencial...",
        text: "Espere un momento mientras se genera la credencial.",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const payload = {
          ...obtenerPayload(row),

          envio_correo: row.getValue("envio_correo"),
          asistio: row.getValue("asistio"),

          estado: "Activo",
          emitido: "Acredita",
        };

        const response = await axios({
          method: "post",
          auth: API_AUTH,
          url: `${API_URL}/CreaCertificado`,
          data: payload,
        });

        const respuesta = response.data;

        await Swal.fire({
          title: "CREDENCIAL",
          html: `
          <p>${respuesta.resultado || ""}</p>
          <p>
            <a
              href="${respuesta.url}"
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong>🔗 Abrir credencial</strong>
            </a>
          </p>
        `,
          icon: "success",
          confirmButtonText: "Confirmar",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
        });

        const deleteResponse = await axios({
          method: "delete",
          url: `${API_URL}/ElminaPendiente/` + row.getValue("id"),
        });

        await Swal.fire({
          title: deleteResponse.data,
          text: "Una vez emitido no podrá regresar.",
          icon: "success",
          confirmButtonText: "OK",
        });

        window.location.reload();
      } catch (error) {
        console.error(error);

        Swal.fire({
          title: "Error",
          text: "Error al actualizar.",
          icon: "error",
        });
      }
    },
    [obtenerPayload],
  );

  // ==========================================================
  // IDIOMAS
  // ==========================================================

  const generarIdioma = useCallback(
    async (row, entidad, idioma) => {
      try {
        const response = await axios({
          method: "post",
          auth: API_AUTH,
          url:
            `${API_URL}/GeneraSGIdiomas/` +
            `${row.getValue("modulo")}/${entidad}/${idioma}`,
          data: obtenerPayload(row),
        });

        await Swal.fire({
          title: "Generado",
          html: `
            <p>Documento generado correctamente.</p>
            <p>
              <a
                href="${response.data}"
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>🔗 Abrir documento</strong>
              </a>
            </p>
          `,
          icon: "success",
          confirmButtonText: "Aceptar",
        });

        window.location.reload();
      } catch (error) {
        console.error(error);

        Swal.fire({
          title: "Error",
          text: "Verifique los campos.",
          icon: "error",
          timer: 4000,
        });
      }
    },
    [obtenerPayload],
  );

  const btnEspanol = useCallback(
    (row) => generarIdioma(row, "IQ", "es"),
    [generarIdioma],
  );

  const btnIngles = useCallback(
    (row) => generarIdioma(row, "IQ", "en"),
    [generarIdioma],
  );

  const btnEspanolIcontec = useCallback(
    (row) => generarIdioma(row, "ICONTEC", "es"),
    [generarIdioma],
  );

  const btnInglesIcontec = useCallback(
    (row) => generarIdioma(row, "ICONTEC", "en"),
    [generarIdioma],
  );

  // ==========================================================
  // BOTÓN DE ACCIÓN REUTILIZABLE
  // ==========================================================

  const ActionButton = ({ title, onClick, children, color = "default" }) => (
    <Tooltip arrow placement="top" title={title}>
      <IconButton
        size="small"
        color={color}
        onClick={onClick}
        sx={{
          width: 34,
          height: 34,
          border: "1px solid",
          borderColor: "divider",
          backgroundColor: "#fff",
          transition: "all .2s ease",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: 2,
            backgroundColor: "#f5f5f5",
          },
        }}
      >
        {children}
      </IconButton>
    </Tooltip>
  );

  // ==========================================================
  // GRUPO DE ACCIONES
  // ==========================================================

  const ActionGroup = ({ title, children, background = "#f8f9fa" }) => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        padding: "4px 6px",
        borderRadius: "8px",
        backgroundColor: background,
        border: "1px solid #e5e7eb",
      }}
    >
      {children}
    </Box>
  );

  // ==========================================================
  // ACCIONES DE FILA
  // ==========================================================

  const renderRowActions = ({ row }) => {
    const emitido = row.getValue("emitido");
    const dato15 = row.getValue("dato_15");

    const esUsuario2 = tipoUsuario == "2";
    const esUsuario6 = tipoUsuario == "6";
    const esAdmin = tipoUsuario == "1";
    const esUsuario7 = tipoUsuario == "7";

    if (esUsuario2) {
      return null;
    }

    return (
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 0.7,
          maxWidth: {
            xs: "260px",
            sm: "420px",
            md: "620px",
            lg: "850px",
          },
          padding: "5px",
          borderRadius: "10px",
          backgroundColor: "#fafafa",
        }}
      >
        {/* ==================================================
            DOCUMENTOS EN BLANCO
        ================================================== */}

        {!esUsuario6 && dato15 !== "Campus" && (
          <ActionGroup background="#f3f4f6">
            <ActionButton
              title="En Blanco ICONTEC con Firma"
              onClick={() => btnEnblancoIcontec(row)}
            >
              <FaFile size={15} />
            </ActionButton>

            <ActionButton
              title="En Blanco ICONTEC sin Firma"
              onClick={() => btnEnblancoIcontecSinFirma(row)}
            >
              <FaFile size={15} />
            </ActionButton>

            <ActionButton
              title="En Blanco IQNET"
              onClick={() => btnEnblancoIQNET(row)}
            >
              <FaFile size={15} />
            </ActionButton>
          </ActionGroup>
        )}

        {/* ==================================================
            HISTORIAL
        ================================================== */}

        {esAdmin && (
          <ActionGroup background="#eef5ff">
            <ActionButton
              title="Ver Histórico General"
              color="primary"
              onClick={() => btnHistorialGeneral(row)}
            >
              <FaHistory size={15} />
            </ActionButton>
          </ActionGroup>
        )}

        {!esUsuario6 && emitido === "Acredita" && (
          <ActionGroup background="#eef5ff">
            <ActionButton
              title="Revocar"
              color="primary"
              onClick={() => btnRevoca(row)}
            >
              <FaHistory size={15} />
            </ActionButton>
          </ActionGroup>
        )}

        {/* ==================================================
            CONSULTAS / CERTIFICADOS
        ================================================== */}

        <ActionGroup background="#f0fdf4">
          {emitido === "Interno" && dato15 === "Campus" && (
            <ActionButton
              title="Ver Certificado"
              color="success"
              onClick={() => btnInterno(row)}
            >
              <FaFilePdf size={15} />
            </ActionButton>
          )}

          {emitido === "Acredita" && (
            <ActionButton
              title="Ver Certificados"
              color="primary"
              onClick={() => btnConsultaSG(row)}
            >
              <FaFilePdf size={15} />
            </ActionButton>
          )}

          {emitido === "Interno" && dato15 !== "Campus" && (
            <>
              <ActionButton
                title="Ver Certificado IQ"
                onClick={() => btnSendInterno(row)}
              >
                <FaFilePdf size={15} />
              </ActionButton>

              <ActionButton
                title="Ver Certificado ICONTEC"
                color="primary"
                onClick={() => btnConsultaSG(row)}
              >
                <FaFilePdf size={15} />
              </ActionButton>
            </>
          )}

          {emitido === "Migrado" && (
            <>
              <ActionButton
                title="Ver Certificado"
                color="primary"
                onClick={() => btnConsultaSG(row)}
              >
                <FaFilePdf size={15} />
              </ActionButton>

              <ActionButton
                title="Ver Certificado IQ"
                onClick={() => btnSendInterno(row)}
              >
                <FaFilePdf size={15} />
              </ActionButton>
            </>
          )}
        </ActionGroup>

        {/* ==================================================
            ACREDITA
        ================================================== */}

        {esAdmin &&
          emitido !== "Acredita" &&
          (emitido === "Interno" || emitido === "Migrado") && (
            <ActionGroup background="#fff1f2">
              <ActionButton
                title="Emitir Acredita"
                color="error"
                onClick={() => Acredita(row)}
              >
                <FaArrowAltCircleRight size={16} />
              </ActionButton>
            </ActionGroup>
          )}

        {/* ==================================================
            ANEXOS
        ================================================== */}

        {!esUsuario6 && (
          <ActionGroup background="#fff7ed">
            <ActionButton
              title="Ver Anexo"
              color="warning"
              onClick={() => btnInforme(row)}
            >
              <FaFilePdf size={15} />
            </ActionButton>

            {dato15 === "Send" && (
              <ActionButton
                title="Ver Anexo en Blanco"
                onClick={() => btnInformeBlanco(row)}
              >
                <FaFilePdf size={15} />
              </ActionButton>
            )}
          </ActionGroup>
        )}

        {/* ==================================================
            USUARIO 6 - ANEXO
        ================================================== */}

        {esUsuario6 && (
          <ActionGroup background="#fff7ed">
            <ActionButton
              title="Ver Anexo"
              color="warning"
              onClick={() => btnInforme(row)}
            >
              <FaFilePdf size={15} />
            </ActionButton>
          </ActionGroup>
        )}

        {/* ==================================================
            REVOCAR
        ================================================== */}

        {(esAdmin && !esUsuario6) ||
          (esUsuario7 && (
            <ActionGroup background="#eff6ff">
              <ActionButton
                title="Revocar Certificado"
                color="info"
                onClick={() => btnRevoca(row)}
              >
                <Update fontSize="small" />
              </ActionButton>
            </ActionGroup>
          ))}

        {/* ==================================================
            IDIOMAS IQ
        ================================================== */}

        {!esUsuario6 && emitido === "Interno" && dato15 === "Send" && (
          <ActionGroup background="#f5f3ff">
            <ActionButton
              title="Generar Español IQ"
              color="success"
              onClick={() => btnEspanol(row)}
            >
              <FaLanguage size={16} />
            </ActionButton>

            <ActionButton
              title="Generar Inglés IQ"
              color="primary"
              onClick={() => btnIngles(row)}
            >
              <FaLanguage size={16} />
            </ActionButton>
          </ActionGroup>
        )}

        {/* ==================================================
            IDIOMAS ICONTEC
        ================================================== */}

        {!esUsuario6 && emitido === "Interno" && dato15 === "Send" && (
          <ActionGroup background="#ecfeff">
            <ActionButton
              title="Generar Español ICONTEC"
              color="success"
              onClick={() => btnEspanolIcontec(row)}
            >
              <FaLanguage size={16} />
            </ActionButton>

            <ActionButton
              title="Generar Inglés ICONTEC"
              color="primary"
              onClick={() => btnInglesIcontec(row)}
            >
              <FaLanguage size={16} />
            </ActionButton>
          </ActionGroup>
        )}
      </Box>
    );
  };

  // ==========================================================
  // RENDER
  // ==========================================================

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#f5f7fa",
        padding: {
          xs: "12px",
          sm: "20px",
          md: "30px",
        },
      }}
    >
      {/* ======================================================
          HEADER
      ====================================================== */}

      <Box
        sx={{
          maxWidth: "1600px",
          margin: "0 auto",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: "14px",
            padding: {
              xs: "18px",
              md: "25px",
            },
            marginBottom: "20px",
            boxShadow: "0 2px 10px rgba(0,0,0,.06)",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              color: "#0085CA",
              fontWeight: 700,
              textAlign: "center",
              marginBottom: "8px",
            }}
          >
            Consulta de certificados
          </Typography>

          <Typography
            sx={{
              textAlign: "center",
              color: "#6b7280",
              fontSize: "14px",
            }}
          >
            Consulte la información del certificado ingresando los datos
            correspondientes.
          </Typography>
        </Box>

        {/* ====================================================
            FORMULARIO
        ==================================================== */}

        {list.length === 0 && (
          <Box
            component="form"
            onSubmit={postData}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "16px",
              padding: {
                xs: "20px",
                sm: "25px",
                md: "32px 40px",
              },
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.06)",
              marginBottom: "20px",
            }}
          >
            {/* TÍTULO */}
            <Typography
              sx={{
                color: "#002E5D",
                fontWeight: 700,
                fontSize: {
                  xs: "18px",
                  md: "21px",
                },
                marginBottom: "28px",
              }}
            >
              Datos de consulta
            </Typography>

            {/* CAMPOS */}
            <Box
              sx={{
                display: "grid",

                // En móvil: 1 columna
                // En tablet: 2 columnas
                // En escritorio: 3 columnas
                gridTemplateColumns: {
                  xs: "1fr",
                  sm: "repeat(2, 1fr)",
                  lg: "repeat(3, 1fr)",
                },

                gap: {
                  xs: "20px",
                  sm: "22px",
                  lg: "28px",
                },

                alignItems: "start",
              }}
            >
              {/* =========================
          CERTIFICADO
      ========================= */}
              <Box sx={{ width: "100%" }}>
                <Typography
                  component="label"
                  sx={{
                    display: "block",
                    color: "#002E5D",
                    fontWeight: 700,
                    fontSize: "16px",
                    marginBottom: "8px",
                  }}
                >
                  Certificado <span style={{ color: "#d32f2f" }}>*</span>
                </Typography>

                <input
                  type="text"
                  className="form-control"
                  value={postCertificado}
                  onChange={(e) => setPostCertificado(e.target.value)}
                  placeholder="Número de certificado"
                  style={{
                    width: "100%",
                    height: "48px",
                    borderRadius: "8px",
                    border: "1px solid #ced4da",
                    padding: "10px 14px",
                    fontSize: "15px",
                    boxSizing: "border-box",
                  }}
                />
              </Box>

              {/* =========================
          DOCUMENTO
      ========================= */}
              <Box sx={{ width: "100%" }}>
                <Typography
                  component="label"
                  sx={{
                    display: "block",
                    color: "#002E5D",
                    fontWeight: 700,
                    fontSize: "16px",
                    marginBottom: "8px",
                  }}
                >
                  Documento
                </Typography>

                <input
                  type="text"
                  className="form-control"
                  value={postDocumento}
                  onChange={(e) => setPostDocumento(e.target.value)}
                  placeholder="Número de documento"
                  style={{
                    width: "100%",
                    height: "48px",
                    borderRadius: "8px",
                    border: "1px solid #ced4da",
                    padding: "10px 14px",
                    fontSize: "15px",
                    boxSizing: "border-box",
                  }}
                />
              </Box>

              {/* =========================
          EMPRESA / NOMBRE
      ========================= */}
              <Box sx={{ width: "100%" }}>
                <Typography
                  component="label"
                  sx={{
                    display: "block",
                    color: "#002E5D",
                    fontWeight: 700,
                    fontSize: "16px",
                    marginBottom: "8px",
                  }}
                >
                  Empresa o Nombre
                </Typography>

                <input
                  type="text"
                  className="form-control"
                  value={postEmpresa}
                  onChange={(e) => setPostEmpresa(e.target.value)}
                  placeholder="Empresa o nombre"
                  style={{
                    width: "100%",
                    height: "48px",
                    borderRadius: "8px",
                    border: "1px solid #ced4da",
                    padding: "10px 14px",
                    fontSize: "15px",
                    boxSizing: "border-box",
                  }}
                />
              </Box>
            </Box>

            {/* =========================
        BOTÓN
    ========================= */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: {
                  xs: "25px",
                  md: "32px",
                },
              }}
            >
              <Button
                type="submit"
                variant="contained"
                size="large"
                disabled={loading}
                startIcon={<Search />}
                sx={{
                  backgroundColor: "#0085CA",
                  minWidth: {
                    xs: "100%",
                    sm: "220px",
                  },
                  height: "48px",
                  borderRadius: "8px",
                  fontWeight: 700,
                  fontSize: "15px",
                  boxShadow: "0 4px 12px rgba(0, 133, 202, 0.25)",

                  "&:hover": {
                    backgroundColor: "#006fa8",
                    boxShadow: "0 5px 15px rgba(0, 133, 202, 0.35)",
                  },

                  "&:disabled": {
                    backgroundColor: "#b8c9d2",
                    color: "#fff",
                  },
                }}
              >
                {loading ? "CONSULTANDO..." : "CONSULTAR"}
              </Button>
            </Box>
          </Box>
        )}

        {/* ====================================================
            RESULTADOS
        ==================================================== */}

        {list.length > 0 && (
          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: "14px",
              padding: {
                xs: "10px",
                md: "18px",
              },
              boxShadow: "0 2px 10px rgba(0,0,0,.06)",
            }}
          >
            {/* BARRA SUPERIOR */}

            <Box
              sx={{
                display: "flex",
                flexDirection: {
                  xs: "column",
                  sm: "row",
                },
                justifyContent: "space-between",
                alignItems: {
                  xs: "stretch",
                  sm: "center",
                },
                gap: 2,
                marginBottom: "15px",
              }}
            >
              <Box>
                <Typography
                  sx={{
                    color: "#002E5D",
                    fontWeight: 700,
                    fontSize: "18px",
                  }}
                >
                  Resultado de la consulta
                </Typography>

                <Typography
                  sx={{
                    color: "#6b7280",
                    fontSize: "13px",
                  }}
                >
                  {list.length} registro
                  {list.length !== 1 ? "s" : ""} encontrado
                  {list.length !== 1 ? "s" : ""}
                </Typography>
              </Box>

              <Button
                variant="outlined"
                startIcon={<Refresh />}
                onClick={Recarga}
                sx={{
                  borderColor: "#0085CA",
                  color: "#0085CA",
                  fontWeight: 600,
                  borderRadius: "8px",
                  "&:hover": {
                    borderColor: "#006fa8",
                    backgroundColor: "#f0f9ff",
                  },
                }}
              >
                Nueva consulta
              </Button>
            </Box>

            {/* TABLA */}

            <MaterialReactTable
              localization={MRT_Localization_ES}
              enableStickyHeader
              enableStickyFooter
              columns={columns}
              data={list}
              enableRowActions
              positionActionsColumn="first"
              renderRowActions={renderRowActions}
              initialState={{
                columnVisibility: {
                  id_certificado: false,
                  showColumnFilters: true,
                },
                density: "compact",
              }}
              muiTableContainerProps={{
                sx: {
                  maxHeight: "70vh",
                },
              }}
              muiTablePaperProps={{
                elevation: 0,
                sx: {
                  border: "1px solid #e5e7eb",
                  borderRadius: "10px",
                  overflow: "hidden",
                },
              }}
              muiTableHeadCellProps={{
                sx: {
                  backgroundColor: "#002E5D",
                  color: "#fff",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                },
              }}
              muiTableBodyCellProps={{
                sx: {
                  fontSize: "13px",
                },
              }}
              muiTableBodyRowProps={{
                sx: {
                  "&:hover": {
                    backgroundColor: "#f8fafc",
                  },
                },
              }}
              renderDetailPanel={({ row }) => (
                <Box
                  sx={{
                    padding: "18px",
                    backgroundColor: "#f8fafc",
                    borderRadius: "8px",
                    margin: "8px",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#002E5D",
                      fontWeight: 700,
                      marginBottom: "12px",
                    }}
                  >
                    Información del certificado
                  </Typography>

                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: {
                        xs: "1fr",
                        md: "1fr 1fr",
                      },
                      gap: 2,
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{
                          fontSize: "12px",
                          color: "#6b7280",
                        }}
                      >
                        Alcance
                      </Typography>

                      <Typography>
                        {row.original.alcance || "Sin información"}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography
                        sx={{
                          fontSize: "12px",
                          color: "#6b7280",
                        }}
                      >
                        Certificado
                      </Typography>

                      <Typography>
                        {row.original.certificado || "Sin información"}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              )}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default ConsultarAutenticado;
